import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../../lib/api";
import { fmtSlot } from "./ChatParts";

export const ChatBookingForm = ({ choice, onCancel }) => {
  const [f, setF] = useState({ name: "", email: "", phone: "", agree: false });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: k === "agree" ? e.target.checked : e.target.value });

  const pay = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/payments/checkout", {
        lookup_key: choice.visit, origin_url: window.location.origin, consultant_slug: choice.consultant || null,
        start_time: choice.slot, reasons: choice.reasons, invitee_name: f.name, invitee_email: f.email, invitee_phone: f.phone,
        heard_about: "Website chat assistant", visit_source: "ai-assistant",
      });
      window.location.href = data.checkout_url;
    } catch (ex) {
      setErr(formatApiErrorDetail(ex.response?.data?.detail) || "Something went wrong - please try again.");
      setBusy(false);
    }
  };

  const input = "w-full px-3 py-2 text-sm border border-stone-300 rounded-md bg-white focus:outline-none focus:border-bronze-dark";
  return (
    <form onSubmit={pay} data-testid="chat-booking-form" className="bg-white border border-bronze-light/50 rounded-md p-3 space-y-2 text-sm">
      <div className="font-medium">{fmtSlot(choice.slot)}</div>
      <ul className="text-xs text-ink-muted">
        {choice.lines.map((l) => <li key={l.label}>{l.label}</li>)}
        <li data-testid="chat-booking-price-note">The full price is shown on the secure payment page before you pay.</li>
      </ul>
      <input required minLength={2} placeholder="Full name" value={f.name} onChange={set("name")} className={input} data-testid="chat-booking-name" />
      <input required type="email" placeholder="Email" value={f.email} onChange={set("email")} className={input} data-testid="chat-booking-email" />
      <input required placeholder="Mobile number" value={f.phone} onChange={set("phone")} className={input} data-testid="chat-booking-phone" />
      <label className="flex items-start gap-2 text-xs">
        <input type="checkbox" required checked={f.agree} onChange={set("agree")} data-testid="chat-booking-agree" className="mt-0.5 accent-[#8C6643]" />
        <span>I agree to the <Link to="/terms" className="underline">terms</Link> and <Link to="/privacy" className="underline">privacy policy</Link>.</span>
      </label>
      {err && <p className="text-xs text-red-700" data-testid="chat-booking-error">{err}</p>}
      <div className="flex gap-2">
        <button type="submit" disabled={busy} className="btn-primary flex-1 justify-center disabled:opacity-50" data-testid="chat-booking-pay">{busy ? "Opening…" : "Pay securely"}</button>
        <button type="button" onClick={onCancel} className="btn-secondary" data-testid="chat-booking-cancel">Back</button>
      </div>
    </form>
  );
};
